/* eslint-disable jsx-a11y/anchor-is-valid */
import {yupResolver} from '@hookform/resolvers/yup'
import {FC, useEffect, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {Column} from 'react-table'
import {KTCard, KTSVG} from '../../../../../../../../../../_metronic/helpers'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../../../contexts/KTableProvider'
import {useLavanderia} from '../../../../../../../../hooks/useLavanderia'
import {formatDate} from '../../../../../../../../util/dates'
import {ShowSnackBar} from '../../../../../../../../util/functions'
import {useLaundryOperation} from '../../../../../../hooks'
import {LaundryConfigDaysFilter, Reception, TypeClothe} from '../../../../../../model'
import {orderLaundryReception} from '../../../../../../schema/laundryOperation'
import {
  getLaundryConfigDays,
  getPrintOrderOperationReception,
  getReceptionByLaundryOperation,
  getSendEmailOperationReception,
} from '../../../../../../services'
import {ModalTicket} from '../../../../../componentes/Modal/ModalTicket'
import {ModalAddFurniture} from '../modal/ModalAddFurniture'

import moment from 'moment'
import {FormReception} from '../form/reception'
const TableReception: FC = () => {
  const [showModalNew, setShowModalNew] = useState(false)
  const [idPermission, setIdPermission] = useState<any>('')
  const [campamentoId, setCampamentoId] = useState<any>('')
  const [detailpermission, setDetailPermission] = useState<TypeClothe | any>(null)
  const [idReception, setIdReception] = useState<any>(null)
  const [dataHead, setDataHead] = useState<any>(null)
  const [minLength, setMinLength] = useState<string>('')
  const [showOption, setShowOption] = useState<boolean>(false)
  const [showModalPrint, setShowModalPrint] = useState(false)
  const [detailPrint, setDetailPrint] = useState<any>(null)
  const [firstLoad, setFirstLoad] = useState<boolean>(false)
  const {data, setData, setPagination, loading, setLoading, clearSelected, pagination} = useKTable()
  const {currentTabItem, isAllowed} = useLavanderia()
  const {getLaundryOperationDataById} = useLaundryOperation()
  const methods = useForm<Reception>({
    resolver: yupResolver(orderLaundryReception),
  })
  const {setValue, watch} = methods
  const handleClear = () => {
    setIdPermission('')
  }

  const getDataById = async () => {
    const response = await getLaundryOperationDataById(currentTabItem.idToEdit)
    setValue('siteId', response.data.siteId)
    setCampamentoId(response.data.campamentoId)
    setDataHead(response.data)
    let addIdData = response.data.detalle?.map((item: any, index: any) => {
      return {idRopa: index + 1, ...item}
    })
    setData(addIdData)
  }

  const handleGetCountXWeight = (rowData: any) => {
    let countTotal =
      rowData.detalle?.reduce(
        (acumulador: any, elemento: any) => acumulador + elemento.cantidad,
        0,
      ) || 0
    let sumWeight =
      rowData.detalle?.reduce((acumulador: any, elemento: any) => acumulador + elemento.peso, 0) ||
      0
    setValue('pesoTotal', sumWeight)
    setValue('cantidadTotal', countTotal)
  }

  const getConfigDayList = async (filter: LaundryConfigDaysFilter) => {
    try {
      const response = await getLaundryConfigDays(filter, 1)
      if (response.data?.data?.length > 0) {
        return response.data.data[0]?.valor
      } else {
        return 0
      }
    } catch (error) {
      return 0
    }
  }

  const getLaundryOperationByIdList = async (rowData: any) => {
    const dataConfigDays = await getConfigDayList({
      companiaId: rowData.companiaId,
      clienteId: rowData.clienteId,
      siteId: rowData.siteId,
      campamentoId: rowData.campamentoId,
      tipoServicioId: 'ROPA OPERACIÓN',
    })
    let idResponsable = rowData.colaboradorId
    let nombreResopnsable = rowData.colaborador
    let lugarRecep = rowData.recepcion.lugarRecepcion ? rowData.recepcion.lugarRecepcion : ''
    const formattedDate = formatDate(rowData.recepcion.fechaRecepcion) ?? ''
    const fechaLocalProgramada = formatDate(rowData.recepcion.fechaProgramada) ?? ''
    if (rowData.recepcion.id) {
      setValue('fechaRecepcion', formattedDate)
      setValue('lugarRecepcion', lugarRecep)
      setValue('fechaProgramada', fechaLocalProgramada)
    } else {
      setValue('fechaRecepcion', moment().format('YYYY-MM-DD'))
      setValue(
        'fechaProgramada',
        dataConfigDays ? moment().add(dataConfigDays, 'days').format('YYYY-MM-DD') : '',
      )
    }

    setValue('responsable', nombreResopnsable)
    setValue('responsableId', idResponsable)
    setIdReception(rowData.recepcion.id)
  }
  const getReceptionByLaundryOperationList = async (id: any) => {
    try {
      clearSelected()
      setLoading(true)
      const {data: response} = await getReceptionByLaundryOperation(id, pagination.currentPage)
      if (!response.error) {
        let addIdData = response.data?.map((item, index) => {
          return {idRopa: index + 1, ...item}
        })
        setData(addIdData)

        setPagination({
          ...pagination,
          totalResults: response.total,
        })
        let countTotal =
          response.data?.reduce(
            (acumulador: any, elemento: any) => acumulador + elemento.cantidad,
            0,
          ) || 0
        let sumWeight =
          response.data?.reduce(
            (acumulador: any, elemento: any) => acumulador + elemento.peso,
            0,
          ) || 0

        setValue('pesoTotal', sumWeight)
        setValue('cantidadTotal', countTotal)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const handleEdit = (item: TypeClothe) => {
    const filter = data.filter((detail) => detail.id === item.id)
    setDetailPermission(filter[0])
    setIdPermission(item.id)
    setShowModalNew(true)
  }

  useEffect(() => {
    if(currentTabItem.idToEdit){
      getDataById()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage, currentTabItem.idToEdit])
  useEffect(() => {
    if (dataHead) {
      handleGetCountXWeight(dataHead)

      if (!firstLoad) {
        setFirstLoad(true)
        getLaundryOperationByIdList(dataHead)
      }
    }
  }, [dataHead, firstLoad])

  useEffect(() => {
    if (idReception) {
      setShowOption(false)
      getReceptionByLaundryOperationList(idReception)
      setMinLength(watch('fechaRecepcion') ?? '')
    } else {
      setShowOption(true)
    }
  }, [idReception])

  const columns: Column<TypeClothe>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} />,
      id: 'selection',
      Cell: ({...props}) => <KTableSelectionCellNonMultiple id={props.data[props.row.index].id} />,
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Item' />,
      accessor: 'idRopa',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de ropa' />,
      accessor: 'tipoRopa',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Cantidad' />,
      accessor: 'cantidad',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Peso KG' />,
      accessor: 'peso',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Origen' />,
      accessor: 'origen',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Módulo origen' />,
      accessor: 'modulo',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Piso origen' />,
      accessor: 'piso',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Observación' />,
      accessor: 'observaciones',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
      id: 'actions',
      Cell: ({...props}) => (
        <>
          {isAllowed('RECEPCION/EDITAR')
            ? showOption && (
                <div
                  className='d-flex justify-content-center flex-shrink-0'
                  onClick={() => handleEdit(props.data[props.row.index])}
                >
                  <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                    <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
                  </a>
                </div>
              )
            : null}
        </>
      ),
    },
  ]

  const downloadPDF = async () => {
    try {
      const response = await getPrintOrderOperationReception(currentTabItem.idToEdit)
      const blob = new Blob([response.data], {type: 'application/pdf'})
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'archivo.pdf'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (error) {}
  }
  const sendEmail = async () => {
    try {
      const {data: response} = await getSendEmailOperationReception(currentTabItem.idToEdit)
      if (!response.error) {
        ShowSnackBar('Se envío satisfactoriamente, revise su correo')
      } else {
        ShowSnackBar(response.message, 'error')
      }
    } catch (error) {}
  }

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='p-2'>
          <FormProvider {...methods}>
            <FormReception
              setDetailPrint={setDetailPrint}
              setShowModalPrint={setShowModalPrint}
              setFirstLoad={setFirstLoad}
              minLength={minLength}
              getDataById={getDataById}
              setMinLength={setMinLength}
              setShowModalNew={setShowModalNew}
              setDataHead={setDataHead}
              idReception={idReception}
            />
          </FormProvider>
        </div>
        {isAllowed('RECEPCION/LISTAR') && (
          <>
            <KTable data={data} columns={columns} />
            {loading ? <KTableLoading title='Cargando...' /> : null}
          </>
        )}
        <ModalAddFurniture
          show={showModalNew}
          setShow={setShowModalNew}
          getReceptionByLaundryOperationList={getDataById}
          detailpermission={detailpermission}
          idPermission={idPermission}
          setIdPermissionList={handleClear}
          campamentoId={campamentoId}
        />
        <ModalTicket
          show={showModalPrint}
          setShow={setShowModalPrint}
          idPermission={''}
          nameTitle={'recepción'}
          typeTab='reception'
          userTicket={'huesped'}
          data={detailPrint}
          funcSeePDF={downloadPDF}
          funcSendEmail={sendEmail}
        />
      </KTCard>
    </>
  )
}

const TableReceptionWrapper = () => {
  return (
    <KTableProvider>
      <TableReception />
    </KTableProvider>
  )
}
export {TableReceptionWrapper}
